<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="card">
              <div class="input-group">
                <div class="input-group-append">
                  <button class="input-group-text btn btn-sm btn-primary" style="padding: 5px" v-b-modal.create @click="add = {order_id: Math.random().toString().substring(3,12),device_id: devices[0] ? devices[0]._id : '', quantity: 1, date: new Date().toISOString().split('.')[0], client: {type: 'user', company: {country_code: 'SA'}}}"><i class="fa fa-plus"></i> &nbsp;&nbsp; إنشاء فاتورة</button>
                </div>
                <input type="text" class="form-control" placeholder="ابحث هنا..." v-model="q" @change="page = 0;gett();" style="border-radius: 0px; font-size: 18px">
                <div class="input-group-append">
                  <button class="input-group-text" @click="page = 0;gett();" id="basic-addon2"><i class="fa fa-search"></i> &nbsp;&nbsp; بحث</button>
                </div>
              </div>
                <div class="card-body" style="padding: 0px">
                  <div class="col-12 table-responsive" style="padding: 0px">
                    <table class="table table-sm table-striped table-hover">
                      <thead class="border">
                        <th>
                          رقم الطلب
                        </th>
                        <th>
                          التسلسل
                        </th>
                        <th>التاريخ</th>
                        <th>الخدمة</th>
                        <th>المبلغ</th>
                        <th>الحالة</th>
                        <th>
                          خيارات
                        </th>
                      </thead>
                      <tbody>
                        <tr v-for="order in orders" class="border" :key="order._id">
                          <td>
                            {{ order.order_id }}
                          </td>
                          <td>
                            {{ order.serial }}
                          </td>
                          <td>
                            {{ order.date }}
                          </td>
                          <td>
                            {{ order.app }},{{order.service}}
                          </td>
                          <td>
                            {{ order.total }}
                          </td>
                          <td style="padding: 0px">
                            <span v-if="order.status == 0" class="btn btn-sm btn-warning" style="padding: 2px; margin: 0px; border-radius: 2px; width: 100%;">
                              <i class="fa fa-clock-o"></i>
                              في الانتظار
                            </span>
                            <span v-if="order.status == 1" class="btn btn-sm btn-primary" style="padding: 2px; margin: 0px; border-radius: 2px; width: 100%;">
                              <i class="fa fa-check"></i>
                              تم الإرسال
                            </span>
                            <span v-if="order.status == 2" class="btn btn-sm btn-danger" style="padding: 2px; margin: 0px; border-radius: 2px; width: 100%;">
                              <i class="fa fa-times"></i>
                              فشل الإرسال
                            </span>
                            <br>
                            <span v-if="order.isRefund" class="btn btn-sm" style="padding: 2px; margin: 0px; border-radius: 2px; color: #fff; background: #450693; width: 100%;">
                              <i class="fa fa-info"></i>
                              طلب استرجاع
                            </span>
                            <span v-if="order.isRefunded" class="btn btn-sm" style="padding: 2px; margin: 0px; border-radius: 2px; background: #CD2C58; color: #fff; width: 100%;">
                              <i class="fa fa-warning"></i>
                              تم إنشاء طلب استرجاع
                            </span>
                          </td>
                          <td>
                            <button class="btn btn-sm btn-primary" v-b-modal.details style="padding: 3px;" @click="current = order" title="التفاصيل">
                              <i class="fa fa-file-code-o"></i>
                            </button>&nbsp;
                            <button class="btn btn-sm btn-danger" style="padding: 3px; background: #9112BC !important; border: 1px solid #9112BC !important" @click="refund(order)" v-if="order.status == 1 && !order.isRefund && !order.isRefunded" title="طلب استرجاع">
                              <i class="fa fa-refresh"></i>
                            </button>&nbsp;
                            <button class="btn btn-sm btn-danger" style="padding: 3px;" @click="deleteOrder(order)" v-if="order.status != 1" title="حذف">
                              <i class="fa fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-12 text-center g" style="margin-top: -10px">
                    <button class="btn btn-danger btn-sm" v-if="page > 0" @click="page = page-1; gett()">
                      <i class="fa fa-arrow-right"></i>
                      الصفحة السابقة 
                    </button>&nbsp;
                    <button class="btn btn-primary btn-sm" v-if="orders.length >= 100" @click="page = page+1; gett()">
                      الصفحة التالية <i class="fa fa-arrow-left"></i>
                    </button>
                  </div>
                </div>
            </div>
        </div>
    </div>
    <b-modal id="create" title="إنشاء فاتورة" hide-footer>
      <div class="form-group">
        <h5 for="">إختر الجهاز</h5>
        <select class="form-control form-control-lg" v-model="add.device_id">
          <option v-for="device in devices" :key="device._id" :value="device._id">{{ device.title }}</option>
        </select>
      </div>
      <div class="form-group">
        <h5 for="">اسم النظام</h5>
        <input type="text"
          class="form-control form-control-lg" v-model="add.app" placeholder="اكتب هنا...">
      </div>
      <div class="form-group">
        <h5 for="">اسم الخدمة</h5>
        <input type="text"
          class="form-control form-control-lg" v-model="add.service" placeholder="اكتب هنا...">
      </div>
      <div class="form-group">
        <h5 for="">رقم الطلب</h5>
        <input type="text"
          class="form-control form-control-lg" v-model="add.order_id" placeholder="اكتب هنا...">
      </div>
      <div class="form-group">
        <h5 for="">مسلسل</h5>
        <input type="text"
          class="form-control form-control-lg" v-model="add.serial" placeholder="اكتب هنا...">
      </div>
      <div class="form-group">
        <h5 for="">تاريخ الطلب</h5>
        <input type="datetime"
          class="form-control form-control-lg" v-model="add.date" placeholder="اكتب هنا...">
      </div>
      <div class="form-group">
        <h5 for="">الكمية</h5>
        <input type="number"
          class="form-control form-control-lg" v-model="add.quantity" placeholder="اكتب هنا...">
      </div>
      <div class="form-group">
        <h5 for="">سعر الوحدة</h5>
        <input type="number"
          class="form-control form-control-lg" v-model="add.unit_price" placeholder="اكتب هنا...">
      </div>
      <div class="form-group">
        <h5 for="">التكلفة الاجمالية (بدون الضريبة)</h5>
        <input type="text"
          class="form-control form-control-lg" v-model="add.cost" placeholder="اكتب هنا...">
      </div>
      <div class="form-group">
        <h5 for="">قيمة الضريبة</h5>
        <input type="number"
          class="form-control form-control-lg" v-model="add.tax" placeholder="اكتب هنا...">
      </div>
      <div class="form-group">
        <h5 for="">التكلفة الإجمالية (مع الضريبة)</h5>
        <input type="number"
          class="form-control form-control-lg" v-model="add.total" placeholder="اكتب هنا...">
      </div>
      <div class="form-group">
        <h5 for="">طريقة الدفع</h5>
        <input type="text"
          class="form-control form-control-lg" v-model="add.payment_method" placeholder="اكتب هنا...">
      </div>
      <div class="form-group">
        <h5 for="">نوع الفاتورة</h5>
        <select class="form-control form-control-lg" v-model="add.client.type">
          <option value="user">فرد</option>
          <option value="company">شركة</option>
        </select>
      </div>
      <template v-if="add.client.type == 'company'">
          <div class="card card-body">
            <h5>بيانات العميل</h5>
            <div class="form-group">
              <label for="">اسم العميل</label>
              <input type="text"
                class="form-control" v-model="add.client.company.name" placeholder="اكتب هنا...">
            </div>
            <div class="form-group">
              <label for="">رقم التسجيل الضريبي</label>
              <input type="text"
                class="form-control" v-model="add.client.company.vat_number" placeholder="اكتب هنا...">
            </div>
            <div class="form-group">
              <label for="">المدينة</label>
              <input type="text"
                class="form-control" v-model="add.client.company.city" placeholder="اكتب هنا...">
            </div>
            <div class="form-group">
              <label for="">الشارع</label>
              <input type="text"
                class="form-control" v-model="add.client.company.street" placeholder="اكتب هنا...">
            </div>
            <div class="form-group">
              <label for="">المبنى</label>
              <input type="text"
                class="form-control" v-model="add.client.company.building" placeholder="اكتب هنا...">
            </div>
            <div class="form-group">
              <label for="">الحي</label>
              <input type="text"
                class="form-control" v-model="add.client.company.district" placeholder="اكتب هنا...">
            </div>
            <div class="form-group">
              <label for="">رمز الدولة (افتراضي SA)</label>
              <input type="text"
                class="form-control" v-model="add.client.company.country_code" placeholder="اكتب هنا...">
            </div>
            <div class="form-group">
              <label for="">الرمز البريدي</label>
              <input type="text"
                class="form-control" v-model="add.client.company.postal_code" placeholder="اكتب هنا...">
            </div>
          </div>
      </template>
      <div class="col-12 text-center g">
        <button class="btn btn-primary" @click="addNow()">
          إنشاء الفاتورة
        </button>
      </div>
    </b-modal>
    <b-modal id="details" title="تفاصيل الفاتورة" hide-footer>
      <div dir="ltr" class="text-right" v-if="current._id">
        <div class="col-12 text-center">
          <img :src="current.invoice.qr_image" alt="" style="width: 150px; hegiht: 150px; border: 2px solid red; border-radius: 10px">
        </div>
        <div class="form-group">
          <h5 for="">QR Code Value</h5>
          <textarea class="form-control bg-white" v-model="current.invoice.qr" readonly rows="8"></textarea>
        </div>
        <div class="form-group">
          <h5 for="">ZATCA Response</h5>
          <textarea class="form-control bg-white" v-model="current.invoice.response" readonly rows="8"></textarea>
        </div>
        <div class="form-group">
          <h5 for="">XML Invoice</h5>
          <textarea class="form-control bg-white" v-model="current.invoice.invoice" readonly rows="8"></textarea>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import { VBModal, BModal, BFormInput, BTooltip } from "bootstrap-vue";
export default {
  components: {
    // Layouts
    BModal,BFormInput},
  directives: {
    Ripple,BTooltip,
    "b-modal": VBModal,
  },
  data(){
    return {
        user: JSON.parse(localStorage.getItem('user')),
        orders: [],
        current: {},
        original_orders: [],
        add: {client: {}},
        devices: [],
        page: 0,
        q: ""
    }
  },
  created(){
    var g = this;
    g.gett()
    $.post(api + '/user/devices/list', {jwt: g.user.jwt}).then(function(r){
          if(r.status != 100){
              alert('تعذر الاتصال بالخادم')
          }else{
              g.devices = r.response
          }
      }).fail(function(){
          alert('تعذر الاتصال بالخادم')
      })
  },
  methods: {
    gett(){
        var g = this;
        $.post(api + '/user/devices/orders', {jwt: g.user.jwt, q: g.q, page: g.page}).then(function(r){
            if(r.status == 100){
                g.orders = r.response
            }else{
                alert(r.response, 200)
            }
        }).fail(function(){
            alert('تعذر الاتصال بالخادم')
        })
    },
    deleteOrder(order){
      var g = this;
      if(confirm("متأكد من حذف الطلب؟")){
        $.post(api + '/user/devices/orders/delete', {jwt: g.user.jwt, id: order._id}).then(function(r){
            if(r.status == 100){
                g.gett()
            }else{
                alert(r.response, 200)
            }
        }).fail(function(){
            alert('تعذر الاتصال بالخادم')
        })
      }
    },
    refund(order){
      var g = this;
      if(confirm("متأكد من استرجاع الطلب؟\nسيتم ارسال فاتورة استرجاع الى Zatca.")){
        $.post(api + '/api/refund', {jwt: g.user.jwt + ',' + order.device_id, order_id: order.order_id}).then(function(r){
            if(r.status == "OK"){
                g.gett()
            }else{
                alert(r.response, 200)
            }
        }).fail(function(){
            alert('تعذر الاتصال بالخادم')
        })
      }
    },
    addNow(){
      var g = this;
      g.add.jwt = g.user.jwt + ',' + g.add.device_id;
      $.post(api + '/api/send-order', g.add).then(function(r){
          if(r.status == 'OK'){
            g.gett()
              $("#create___BV_modal_header_ > button").click()
          }else{
              alert(r.response, 200)
          }
      }).fail(function(){
          alert('تعذر الاتصال بالخادم')
      })
    }
  }

}
</script>

<style>
.text-right input{
    text-align: right;
}
</style> 